export default __webpack_public_path__ + "f0d75d9ade127cd05ff6fc477a198c99.png";